import { Typography } from '@design-system/components/typography/typography';
import { FormDataMultiSelect } from '../viewModel/otpBundles.viewModel';
import { isEmpty } from 'lodash';
import { DropDownMultiselect } from '@client/new/pages/bundles/otp/view/dropDownMultiselect/dropDownMultiselect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { sprinkles } from '@design-system/sprinkles.css';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';

export const ContentSection = <T extends string | number>({
  sectionTitle,
  emptyState,
  options,
  selectedItems,
  disabled,
  value,
  onChange,
  toFormOnChange,
}: FormDataMultiSelect<T> & {
  disabled: boolean;
  value: T[];
  onChange: (value: T[]) => void;
}) => {
  if (isEmpty(options)) {
    return (
      <div className="flex flex-col gap-4">
        <Typography variant="body" size="large">
          {sectionTitle}
        </Typography>
        <div className="flex gap-1 items-center">
          <Typography
            variant="body"
            size="medium"
            color="N-80"
            className="underline cursor-pointer"
            onClick={emptyState.onClick}
          >
            {emptyState.urlLabel}
          </Typography>
          <Typography variant="body" size="medium" color="N-80">
            {emptyState.label}
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <Typography
        variant="body"
        size="large"
        color={disabled ? 'N-60' : 'B-100'}
      >
        {sectionTitle}
      </Typography>
      <DropDownMultiselect
        items={options}
        disabled={disabled}
        value={value}
        onChange={onChange}
        toFormOnChange={toFormOnChange}
      />
      <ContentList
        selectedItems={selectedItems}
        disabled={disabled}
        onChange={onChange}
        toFormOnChange={toFormOnChange}
        value={value}
      />
    </div>
  );
};

const ContentList = <T extends string | number>({
  selectedItems,
  disabled,
  onChange,
  toFormOnChange,
  value,
}: Pick<FormDataMultiSelect<T>, 'selectedItems' | 'toFormOnChange'> & {
  disabled: boolean;
  value: T[];
  onChange: (value: T[]) => void;
}) => (
  <div>
    {selectedItems.map((item) => (
      <div
        key={item.id}
        className="flex justify-between border-b-[1px] border-[#E2E2E2] py-2 gap-2"
      >
        <Typography
          color={disabled ? 'N-60' : 'B-100'}
          className="overflow-x-hidden"
        >
          {item.name}
        </Typography>
        {!(disabled || item.disableDelete) && (
          <div className="flex">
            <FontAwesomeIcon
              icon={faTrash}
              onClick={() => {
                const newValues = toFormOnChange(item.id, value || []);
                onChange(newValues);
              }}
              className={sprinkles({
                cursor: 'pointer',
                color: 'B-100',
              })}
            />
          </div>
        )}
      </div>
    ))}
  </div>
);
